import { Serializable } from '../../../core/models/serializable';
import { ProductType } from '../../../product-purchases/shared/models/product-type';

export class SalesReportModel implements Serializable<SalesReportModel> {
  fromObject(object: any): SalesReportModel {
    Object.assign(this, object);

    this.announcementsReportData = [];
    this.cvDatabasesReportData = [];
    this.sliderBannersReportData = [];
    this.additionalProductsReportData = [];
    this.portfolioAnnouncementsReportData = [];
    this.portfolioAdditionalProductsReportData = [];
    this.announcementUpgradesReportData = [];
    this.upgradeCombinationsReportData = [];

    if (
      object.announcementsReportData &&
      object.announcementsReportData.length &&
      object.announcementsReportData.length > 0
    ) {
      object.announcementsReportData.forEach((d) => {
        let t = new ChannelAnnouncementsReportModel();
        t = t.fromObject(d);
        this.announcementsReportData.push(t);
      });
    }

    if (
      object.cvDatabasesReportData &&
      object.cvDatabasesReportData.length &&
      object.cvDatabasesReportData.length > 0
    ) {
      object.cvDatabasesReportData.forEach((d) => {
        let t = new ProductReportModel();
        t = t.fromObject(d);
        this.cvDatabasesReportData.push(t);
      });
    }

    if (
      object.sliderBannersReportData &&
      object.sliderBannersReportData.length &&
      object.sliderBannersReportData.length > 0
    ) {
      object.sliderBannersReportData.forEach((d) => {
        let t = new ProductReportModel();
        t = t.fromObject(d);
        this.sliderBannersReportData.push(t);
      });
    }

    if (
      object.additionalProductsReportData &&
      object.additionalProductsReportData.length &&
      object.additionalProductsReportData.length > 0
    ) {
      object.additionalProductsReportData.forEach((d) => {
        let t = new AdditionalProductsReportModel();
        t = t.fromObject(d);
        this.additionalProductsReportData.push(t);
      });
    }

    if (
      object.portfolioAnnouncementsReportData &&
      object.portfolioAnnouncementsReportData.length &&
      object.portfolioAnnouncementsReportData.length > 0
    ) {
      object.portfolioAnnouncementsReportData.forEach((d) => {
        let t = new PortfolioProductsReportModel();
        t = t.fromObject(d);
        this.portfolioAnnouncementsReportData.push(t);
      });
    }

    if (
      object.portfolioAdditionalProductsReportData &&
      object.portfolioAdditionalProductsReportData.length &&
      object.portfolioAdditionalProductsReportData.length > 0
    ) {
      object.portfolioAdditionalProductsReportData.forEach((d) => {
        let t = new PortfolioProductsReportModel();
        t = t.fromObject(d);
        this.portfolioAdditionalProductsReportData.push(t);
      });
    }

    if (
      object.announcementUpgradesReportData &&
      object.announcementUpgradesReportData.length &&
      object.announcementUpgradesReportData.length > 0
    ) {
      object.announcementUpgradesReportData.forEach((d) => {
        let t = new ProductReportModel();
        t = t.fromObject(d);
        this.announcementUpgradesReportData.push(t);
      });
    }

    if (
      object.upgradeCombinationsReportData &&
      object.upgradeCombinationsReportData.length &&
      object.upgradeCombinationsReportData.length > 0
    ) {
      object.upgradeCombinationsReportData.forEach((d) => {
        let t = new ProductReportModel();
        t = t.fromObject(d);
        this.upgradeCombinationsReportData.push(t);
      });
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public announcementsReportData: ChannelAnnouncementsReportModel[];
  public cvDatabasesReportData: ProductReportModel[];
  public sliderBannersReportData: ProductReportModel[];
  public additionalProductsReportData: AdditionalProductsReportModel[];
  public portfolioAnnouncementsReportData: PortfolioProductsReportModel[];
  public portfolioAdditionalProductsReportData: PortfolioProductsReportModel[];
  public announcementUpgradesReportData: ProductReportModel[];
  public upgradeCombinationsReportData: ProductReportModel[];
  public renewals: number;
  public totalAnnouncements: number;
  public totalRenewalCount: number;

  constructor() {
    this.announcementsReportData = [];
    this.cvDatabasesReportData = [];
    this.sliderBannersReportData = [];
    this.additionalProductsReportData = [];
    this.portfolioAnnouncementsReportData = [];
    this.portfolioAdditionalProductsReportData = [];
    this.announcementUpgradesReportData = [];
    this.upgradeCombinationsReportData = [];
  }

  public getAnnouncementsReportTotal(name: string) {
    switch (name) {
      case 'vipCV': {
        return this.announcementsReportData
          .map((a) => a.vipCV)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'vip': {
        return this.announcementsReportData
          .map((a) => a.vip)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'exclusive': {
        return this.announcementsReportData
          .map((a) => a.exclusive)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'premium': {
        return this.announcementsReportData
          .map((a) => a.prioPremium)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'standard': {
        return this.announcementsReportData
          .map((a) => a.prioStandard)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'start': {
        return this.announcementsReportData
          .map((a) => a.prioStart)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'regular': {
        return this.announcementsReportData
          .map((a) => a.regular)
          .reduce((sum, curr) => sum + curr, 0);
      }
      case 'regularPreview': {
        return this.announcementsReportData
          .map((a) => a.regularPreview)
          .reduce((sum, curr) => sum + curr, 0);
      }
    }
  }

  public getChannelTotal(channelName: string, onlySold: boolean) {
    let total = 0;
    let report =
      channelName != null
        ? this.announcementsReportData.filter((a) => a.channel == channelName)
        : this.announcementsReportData;

    report.forEach((r) => {
      total += onlySold
        ? r.sold
        : r.vipCV +
          r.vip +
          r.exclusive +
          r.prioPremium +
          r.prioStandard +
          r.prioStart +
          r.regular +
          r.regularPreview;
    });
    return total;
  }

  public getCvDbTotal(free: boolean) {
    return this.cvDatabasesReportData
      .map((c) => (free ? c.totalFree : c.totalSold))
      .reduce((sum, curr) => sum + curr, 0);
  }

  public getSliderTotal(free: boolean) {
    return this.sliderBannersReportData
      .map((s) => (free ? s.totalFree : s.totalSold))
      .reduce((sum, curr) => sum + curr, 0);
  }
}

export class ChannelAnnouncementsReportModel
  implements Serializable<ChannelAnnouncementsReportModel>
{
  fromObject(object: any): ChannelAnnouncementsReportModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public channel: string;
  public vipCV: number;
  public vip: number;
  public exclusive: number;
  public prioPremium: number;
  public prioStandard: number;
  public prioStart: number;
  public regular: number;
  public regularPreview: number;

  public sold: number;
}

export class ProductReportModel implements Serializable<ProductReportModel> {
  fromObject(object: any): ProductReportModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public name: string;
  public totalFree: number;
  public totalSold: number;
}

export class AdditionalProductsReportModel
  implements Serializable<AdditionalProductsReportModel>
{
  fromObject(object: any): AdditionalProductsReportModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public product: string;
  public count: number;

  public constructor(product: string = null, count: number = 0) {
    this.product = product;
    this.count = count;
  }
}

export class PortfolioProductsReportModel
  implements Serializable<PortfolioProductsReportModel>
{
  fromObject(object: any): PortfolioProductsReportModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public portfolioId: number;
  public productTypeId: ProductType;
  public code: string;
  public totalSold: number;
  public total: number;
}
